<template>
  <div class="table-box">
    <div
      v-if="canEdit"
      class="flex row-right table-btn-group m-b-20"
      :class="{ 'btn-box': isTop }"
    >
      <el-button type="danger" class="m-r-10" @click="handleBatchDelete">
        批量删除
      </el-button>
      <div class="upload-button m-r-10" @click="handleImport">
        <el-button type="primary">批量导入</el-button>
        <input
          v-show="false"
          ref="fileupload"
          type="file"
          name="fileupload"
          :value="uploadFile"
          @change.stop="fileChange"
        />
      </div>
      <download-file download-link="/resources/询比品目导入模板.xlsx">
        <el-button>下载品目导入模板</el-button>
      </download-file>
    </div>
    <el-table
      ref="materialTable"
      border
      highlight-current-row
      header-cell-class-name="table-header"
      :data="pageMaterialList"
      @selection-change="handleMaterialTableSelectionChange"
    >
      <el-table-column v-if="canEdit" type="selection" width="60" fixed />
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed
      />
      <el-table-column
        label="品目编码"
        align="center"
        min-width="100"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品目名称"
        align="center"
        min-width="100"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="数量"
        align="right"
        header-align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{
            row.materielNum ? strToThousands(row.materielNum) : '-'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品目单位"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.unitType || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="参数型号"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品牌/制造商"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielBrand || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!isSupplier"
        :label="`${isWuling && !requireTax ? '预算不含税单价' : '预算单价'}（${isDollar ? '美元' : '元'}）`"
        align="right"
        header-align="center"
        :min-width="isWuling && !requireTax ? 160 : 120"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{
            row.budgetUnitPrice ? strToThousands(row.budgetUnitPrice) : '-'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!isSupplier"
        :label="`${isWuling && !requireTax ? '预算不含税总价' : '总价'}（${isDollar ? '美元' : '元'}）`"
        align="right"
        header-align="center"
        :min-width="isWuling && !requireTax ? 160 : 100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.totalPrice ? strToThousands(row.totalPrice) : '-' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="交货地点"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryAddress || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="交货时间(天)"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryDay || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.remarks || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="附件" align="center" min-width="160">
        <template slot-scope="{ row }">
          <upload
            v-if="row.attachmentFileIds"
            :props-data="{
              disabled: true,
              uploadMode: 'fileId',
              fileIdBefore: row.attachmentFileIds
            }"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="{ row, $index }">
          <el-button
            v-if="canEdit"
            class="primary-button"
            type="text"
            @click="addOrEditMaterialInfo('edit', row)"
          >编辑</el-button>
          <el-button
            v-if="canEdit"
            class="danger-button"
            type="text"
            @click="handleMaterialRemove(row, $index)"
          >删除</el-button>
          <el-button
            type="text"
            @click="handleMaterialLook(row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--      点击添加品目-->
    <div
      v-if="canEdit"
      class="table-btn flex-center"
      @click="addOrEditMaterialInfo('add')"
    >
      <i class="el-icon-plus"></i> 添加品目
    </div>

    <pagination
      v-show="materialList.length > size"
      :total="materialList.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />

    <!--    显示上传品目总价-->
    <div v-if="!isSupplier" class="all-count m-l-24">
      <div class="count-box">
        <div class="all-count__label">全部品目总价汇总：</div>
        <div class="all-count__money">{{ strToThousands(totalFee) }}</div>
        <div class="m-l-4 m-r-10">{{ isDollar ? '美元' : '元' }}</div>
        <money-in-cn v-if="!isDollar" class="m-t-2" :money="totalFee" />
      </div>
    </div>

    <!--    添加或修改品目信息的弹窗-->
    <add-or-edit-material-info-dialog
      v-if="showEditDialog"
      v-model="showEditDialog"
      :is-wuling="isWuling"
      :title="editDialogTitle"
      :material-info="materialInfo"
      :upload-params="defaultUploadParams"
      :is-dollar="isDollar"
      :require-tax="requireTax"
      @change="handleEditDialogShowChange"
      @material="handleMaterial"
    />

    <!--    查看品目信息的弹窗-->
    <material-detail-dialog
      v-if="showDetailDialog"
      v-model="showDetailDialog"
      :is-wuling="isWuling"
      :is-supplier="isSupplier"
      :material-info="materialInfo"
      :is-dollar="isDollar"
      :require-tax="requireTax"
      :upload-params="defaultUploadParams"
      title="品目信息详情"
    />
  </div>
</template>

<script>
// 组件
import AddOrEditMaterialInfoDialog from './AddOrEditMaterialInfoDialog'
import MaterialDetailDialog from './MaterialDetailDialog'
import Upload from '@/components/common/Upload'
import DownloadFile from '@/components/common/DownloadFile'
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
// 接口
import { importMaterialInfoApi } from '@/api/procure/inquiry'
import {
  getMaterialTemplateApi,
  getMaterialTemplatePageApi
} from '@/api/material/template'
// 字典
import { materialTemplateStatusDict } from '@/dictionary/material/template'
import { purchaseTypeDict } from '@/dictionary/project/common'
// 工具方法
import nzh from 'nzh'
import { strToThousands } from '@/utils/utils'
// mixin
import materialColumnMixin from '@/components/common/PurchaseListComponent/material-column-mixin'

export default {
  name: 'MaterialTable',

  components: {
    AddOrEditMaterialInfoDialog,
    MaterialDetailDialog,
    Upload,
    DownloadFile,
    Pagination,
    MoneyInCn
  },

  mixins: [materialColumnMixin],

  props: {
    // 是否是五菱发布的项目
    isWuling: {
      type: Boolean,
      default: false
    },

    // 回显的表格数据
    tableData: {
      type: Array,
      default: () => []
    },

    // 是否是可编辑的
    canEdit: {
      type: Boolean,
      default: true
    },

    // 按钮是否上移
    isTop: {
      type: Boolean,
      default: false
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    // 是否是供应商，供应商查看时隐藏单价与总价
    isSupplier: {
      type: Boolean,
      default: false
    },

    // 外部传入的模板配置
    itemSchemaList: {
      type: Array,
      default: () => []
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    },

    // 报价是否含税
    requireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 品目信息弹窗变量
      showEditDialog: false,
      editDialogTitle: '添加品目信息',
      showDetailDialog: false,

      pageMaterialList: [], // 分页显示的列表
      materialList: [], // 品目列表
      materialInfo: {}, // 暂存的需要操作的品目信息
      materialIndex: -1, // 暂存的需要操作的品目信息在品目表中的下标
      selectedMaterials: [], // 已选择的品目信息

      uploadFile: '', // 上传的文件
      totalFee: 0, // 全部品目总价
      page: 1,
      size: 50
    }
  },

  computed: {
    defaultUploadParams() {
      return this.uploadParams
    },

    totalPage() {
      return this.materialList.length / this.size
    },

    nzhTotalFee() {
      return nzh.cn.encodeB(this.totalFee.toString())
    }
  },

  watch: {
    materialList: {
      deep: true,
      handler: function() {
        this.getTotalFee()
      }
    },

    tableData(newVal) {
      if (newVal.length !== 0) {
        this.materialList = [...this.tableData]
        this.getPageData()
      }
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    },

    itemSchemaList: {
      handler(val) {
        if (val.length === 0) {
          this.getItemSchemaList()
        }
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    if (this.tableData.length !== 0) {
      this.materialList = [...this.tableData]
      this.getPageData()
    }
  },

  methods: {
    strToThousands,

    /**
     * 添加或者编辑品目信息的函数
     * @param {string} type 表示添加还是修改
     * @param {Object} row 当type===edit时使用，需要修改的品目信息
     */
    addOrEditMaterialInfo(type, row) {
      if (type === 'add') {
        this.editDialogTitle = '添加品目信息'
      } else {
        this.editDialogTitle = '修改品目信息'
      }

      if (row) {
        this.materialInfo = row
        this.materialIndex = this.materialList.indexOf(row)
      } else {
        this.materialIndex = -1
      }

      this.showEditDialog = true
    },

    // 弹窗关闭回调
    handleEditDialogShowChange(showDialog) {
      if (!showDialog) this.materialInfo = {}
      this.getPageData()
    },

    // 品目弹窗点击确定回调事件
    handleMaterial(data) {
      // 如果暂存的需要操作的品目信息下标有值，则表示是更新操作，根据下标更新对象值
      if (this.materialIndex >= 0) {
        const tempObj = this.materialList[this.materialIndex]
        this.materialList[this.materialIndex] = Object.assign(tempObj, data)
      } else {
        this.materialList.push(data)
      }
    },

    // 删除品目
    handleMaterialRemove(row, index) {
      this.$systemConfirm('DELETE_MATERIAL').then(result => {
        if (!result) return

        this.materialList.splice(index, 1)
        // this.getTotalFee()
        this.getPageData()
        this.$message.success('删除成功')
      })
    },

    // 查看品目详情
    handleMaterialLook(row) {
      if (row) this.materialInfo = row
      this.showDetailDialog = true
    },

    // 品目表勾选项改变时触发
    handleMaterialTableSelectionChange(selection) {
      this.selectedMaterials = selection
    },

    // 批量删除
    handleBatchDelete() {
      if (this.selectedMaterials.length === 0) {
        this.$message.warning('请先选择需要删除的品目')
        return false
      }

      this.batchRemove()
    },

    // 执行删除操作
    batchRemove() {
      this.$systemConfirm('DELETE_SELECTED_MATERIAL').then(result => {
        if (!result) return

        // 获取已选项在品目列表中的下标
        const tempIndexArray = this.selectedMaterials.map(s => {
          return this.materialList.findIndex(m => m === s)
        })

        // 根据已选项的下标排除数据，返回未选的品目数据
        const tempArray = this.materialList.filter((v, index) => {
          return !tempIndexArray.includes(index)
        })
        // 将未选的品目数据覆盖写入原本的品目表，达到批量删除的目的
        this.materialList = [...tempArray]
        // this.getTotalFee()
        this.getPageData()
        this.$message.success('删除成功')
      })
    },

    // 批量导入
    handleImport() {
      this.$refs.fileupload.click()
    },

    fileChange(e) {
      const fileList = Array.from(e.currentTarget.files)

      if (!fileList[0]) {
        return false
      }

      this.$refs.fileupload.value = ''

      importMaterialInfoApi({ file: fileList[0] })
        .then(res => {
          const tempArray = this.materialList.concat(res.data || [])
          // if (tempArray.length > 999) {
          //   this.$message.warning('品目条数上限为999条')
          //   return false
          // }
          this.materialList = tempArray
          this.getPageData()
        })
        .catch(err => {
          this.$message.error(err.message || '导入失败')
        })
    },

    // 执行本地的总金额计算
    getTotalFee() {
      let fee = 0

      if (this.materialList.length === 0) {
        this.totalFee = fee
        if (this.canEdit) {
          // this.getGuaranteeFee()
          this.$emit('getTotalFee', this.totalFee)
        }
        return false
      }

      this.materialList.forEach(val => {
        fee = fee + Number(val.totalPrice) * 100
      })

      this.totalFee = fee / 100
      // if (this.canEdit) this.getGuaranteeFee()
      if (this.canEdit) {
        this.$emit('getTotalFee', this.totalFee)
      }
    },

    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.materialList.slice(start, end)
    },

    /**
     * 获取默认模板
     */
    async getItemSchemaList() {
      try {
        const { data } = await getMaterialTemplatePageApi({
          page: 1,
          size: 10,
          purchaseType: purchaseTypeDict.INQUIRY.value,
          templateStatus: materialTemplateStatusDict.ENABLE.value
        })
        this.templateList = data.records || []
        const defaultTemplate = this.templateList.length
          ? this.templateList[0]
          : {}
        if (!defaultTemplate.templateId) return
        const templateRes = await getMaterialTemplateApi(
          defaultTemplate.templateId
        )
        const DEFINE_LIST = templateRes.data?.defineList || []
        this.setColumnConfig(DEFINE_LIST)
        console.log('columnConfig', this.columnConfig)
      } catch (error) {
        this.$message.error(error?.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.table-box {
  pointer-events: auto;
}
.table-btn-group {
  padding: 0 pixel-to-rem($n: 30);
  ::v-deep .el-button + .el-button {
    margin-left: pixel-to-rem($n: 30);
  }

  img {
    width: pixel-to-rem($n: 26);
    height: pixel-to-rem($n: 26);
    margin-right: pixel-to-rem($n: 10);
    border: none;
  }
}
.table-btn {
  height: pixel-to-rem($n: 60);
  background-color: $primary-background-color;
  color: $primary-color;
  @include text-bold;
  font-size: pixel-to-rem($n: 18);
  cursor: pointer;

  i {
    @include text-bold;
    font-size: pixel-to-rem($n: 18);
    margin-right: pixel-to-rem($n: 10);
    padding-top: 1px;
  }
}

.btn-box {
  margin-top: -50px;
}

.upload-button {
  display: inline-block;
  cursor: pointer;
  &:hover {
    color: $primary-color;
  }
}

.all-count {
  display: inline-block;
  margin-top: pixel-to-rem($n: 20);
  padding: pixel-to-rem($n: 6) pixel-to-rem($n: 20);
  line-height: 1.5;
  background: $grey-background-color;
  border-radius: 4px;
  .count-box {
    display: flex;
    .all-count__label {
      color: $second-text-color;
      &::before {
        display: inline-block;
        content: '*';
        color: $danger-color;
        margin-right: pixel-to-rem($n: 10);
      }
    }
    .all-count__money {
      @include text-bold;
      color: $text-color;
    }
  }
}
</style>
